import { SQUARE_SHAPE, PORTRAIT_SHAPE, LANDSCAPE_SHAPE } from '../constants';

/**
 * Export the known shape closest to this width and height
 */
export function getShape(shape, width = 1575, height = 1575) {
  if (shape === 'fit') {
    const ratio = height / width;
    const diff = 0.2;
    if (ratio > 1 - diff && ratio < 1 + diff) {
      return SQUARE_SHAPE;
    } else if (ratio >= 1 + diff) {
      return PORTRAIT_SHAPE;
    } else {
      return LANDSCAPE_SHAPE;
    }
  }
  return shape;
}
